"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AzureContent = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _moment = _interopRequireDefault(require("moment"));
var _msalBrowser = require("@azure/msal-browser");
var _msalReact = require("@azure/msal-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _user = require("../entities/user");
var _AzureRouting = require("./AzureRouting");
var _Types = require("../Types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Azure wrap
 *
 * @param {Element: required}  children content
 * @param {Required} authFile File to set login settings, if null - default auth file for local development is used
 * @param {JSX.Element} loginComponent Custom login page, only as a Tag
 *
 * @returns {JSX.Element}
 *
 * @private
 */
const AzureContent = _ref => {
  let {
    children,
    authFile = null,
    loginComponent = null
  } = _ref;
  const {
    instance,
    inProgress,
    accounts
  } = (0, _msalReact.useMsal)();
  const ticker = (0, _react.useRef)(null);
  const dispatch = (0, _reactRedux.useDispatch)();
  const [apiData] = (0, _react.useState)(null);
  const [expiresOn, setExpiresOn] = (0, _react.useState)(null);
  const authLogic = (0, _react.useCallback)(() => {
    if (accounts && accounts[0]) {
      const accessTokenRequest = {
        scopes: ['user.read'],
        account: accounts[0]
      };
      instance.acquireTokenSilent(accessTokenRequest).then(accessTokenResponse => {
        dispatch((0, _user.setTokenAction)(accessTokenResponse.accessToken));
        dispatch((0, _user.setTokenParamsAction)(accessTokenResponse));
        setExpiresOn(accessTokenResponse.expiresOn);
        dispatch((0, _user.setUserAction)(accounts[0]));
      }).catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
        if (error instanceof _msalBrowser.InteractionRequiredAuthError) {
          instance.acquireTokenRedirect(accessTokenRequest).then(() => {});
        }
        dispatch((0, _user.setTokenAction)(null));
        dispatch((0, _user.setTokenParamsAction)({
          expiresOn: null
        }));
        setExpiresOn(null);
        dispatch((0, _user.resetUserAction)());
      });
    }
  }, [accounts, instance, dispatch]);
  (0, _react.useEffect)(() => {
    if (!apiData && inProgress === _msalBrowser.InteractionStatus.None) {
      authLogic();
    }
  }, [apiData, authLogic, inProgress]);
  (0, _react.useEffect)(() => {
    if (expiresOn) {
      const leftBeforeExpired = (0, _moment.default)(expiresOn).diff((0, _moment.default)());
      if (ticker.current) clearTimeout(ticker.current);
      /** * 10 milliseconds after the token becomes expired call for an update */
      ticker.current = setTimeout(authLogic, leftBeforeExpired + 10);
    }
    return () => ticker.current && clearTimeout(ticker.current);
  }, [authLogic, dispatch, expiresOn]);
  return /*#__PURE__*/_react.default.createElement(_AzureRouting.AzureRouting, {
    loginComponent: loginComponent,
    authFile: authFile
  }, children);
};
exports.AzureContent = AzureContent;
AzureContent.propTypes = {
  children: _propTypes.default.element.isRequired,
  authFile: _Types.AuthFileType,
  loginComponent: _propTypes.default.element
};
AzureContent.defaultProps = {
  authFile: null,
  loginComponent: null
};